import { axiosInstance, axiosInstanceForm } from "../../Utils/AxiosInstance";

/**
 * Vendors API Service
 * Mock API calls for Vendors management
 * Using dummy endpoints that follow the system pattern
 */

export const GetAllVendorsApi = async (project_id) => {
  try {
    // No project_id = business-wide (vendors aren't project-scoped). Old:
    // const response = await axiosInstance.get(`/Vendors/GetAll?ProjectId=${project_id}`);
    const query = project_id ? `?ProjectId=${project_id}` : "";
    const response = await axiosInstance.get(`/Vendors/GetAll${query}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddVendorApi = async (data) => {
  try {
    const response = await axiosInstanceForm.post(`/Vendors/Add`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdateVendorApi = async (data, vendorId) => {
  try {
    const response = await axiosInstanceForm.put(`/Vendors/Update?vendorId=${vendorId}`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const DeleteVendorApi = async (vendorId, projectId) => {
  try {
    const response = await axiosInstance.delete(
      `/Vendors/Delete?vendorId=${vendorId}&projectId=${projectId}`,
    );
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};
